<div class="cab-dialog-container displayFlexColumn">
    <section class="header displayFlexSpaceBetween align-item-center">
        <h1 class="fs-16 font-weight-700">Define High Capacity Cabs</h1>
        <button mat-dialog-close class="close">
            <img src="assets/cross.svg" alt="close"/>
        </button>
    </section>
    <section class="body displayFlexColumn border-bottom-E0E0E0">
        <div class="note displayFlex fs-14 text-light">
            <img src="assets/policy-error.svg" alt="note">
            Please choose cab types that will be defined as high capacity.
        </div>
        <div class="table-box displayFlexColumn">
            <div class="header-section displayFlexSpaceBetween align-item-center">
                <div class="col-heading fs-14 font-weight-700">Cab Type</div>
                <div class="col-heading fs-14 font-weight-700">Action</div>
            </div>
            <div class="cab-type-section displayFlexColumn">
                <div class="rows displayFlexSpaceBetween align-item-center" 
                *ngFor="let cab of cabsData; let last = last"
                [ngClass]="{'border-bottom-E0E0E0': !last}"
                >
                    <span>{{cab.cabType}}</span>
                    <div class="checkbox-container displayFlexCenter align-item-center">
                        <mis-checkbox
                        [type]="'Default'"
                        [checked]="cab.highCapacity"
                        [name]="cab.cabType"
                        (valueChange)="handleCheckboxClick($event)"
                        >
                        </mis-checkbox>
                    </div>
                </div>
            </div>
        </div>
       
    </section>
    <section class="footer displayFlex align-item-center">
        <button mat-dialog-close class="cancel-btn fs-16 font-weight-700">Cancel</button>
        <button (click)="saveChanges()" class="save-btn fs-16 font-weight-700" [ngClass]="{'disabled': !isEdited}">Save</button>
    </section>
</div>